import { Badge } from '@klear/ui/components/badge'
import { canDecideStep } from '@/app/document-review/approve-row'
import { commitPhrases } from '@/app/document-review/commit-summary'
import type { DocumentReviewDetailOutput } from '@/app/document-review/use-document-review'

export type CommitBarProps = {
  detail: DocumentReviewDetailOutput
  canEdit: boolean
}

const KEY_LEGEND = [
  ['↵', 'confirm, then next'],
  ['space', 'confirm or undo'],
  ['e', 'correct'],
  ['↑ ↓', 'previous, next'],
  ['⌘ or Ctrl ↵', 'create records']
] as const

export function CommitBar({ detail, canEdit }: CommitBarProps) {
  const decidable = canDecideStep(detail.step)

  return (
    <div className="bg-card shrink-0 rounded-lg border px-3 py-2">
      <div className="flex flex-wrap items-center gap-1.5">
        {commitPhrases(detail).map((phrase) => (
          <Badge key={phrase} variant="secondary" className="font-normal">
            {phrase}
          </Badge>
        ))}
      </div>

      {canEdit && decidable && (
        <p className="text-muted-foreground mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs">
          {KEY_LEGEND.map(([key, meaning]) => (
            <span key={key}>
              <kbd className="bg-muted rounded px-1 py-0.5 font-mono text-[11px]">{key}</kbd> {meaning}
            </span>
          ))}
        </p>
      )}
    </div>
  )
}
